import { render, staticRenderFns } from "./rekonfakr.vue?vue&type=template&id=71d2926a"
import script from "./rekonfakr.vue?vue&type=script&lang=js"
export * from "./rekonfakr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports